import CoreBase from '../../../services/engines/CoreBase';
import ComponentNotifier from '../../../services/wss/ComponentNotifier';

export const _name = 'AppBarEngine';

/**
 * AppBarEngine — controls AppBar visibility independently of focus mode.
 * Singleton. Consumers subscribe via useAppBarVisible hook.
 */
class AppBarEngine extends CoreBase {
    _hidden = false;

    /**
     * Hides the AppBar and notifies subscribers.
     */
    hide = () => {
        if (this._hidden) return;
        this._hidden = true;
        ComponentNotifier.notify(_name, 'visibilityChanged');
    };

    /**
     * Shows the AppBar and notifies subscribers.
     */
    show = () => {
        if (!this._hidden) return;
        this._hidden = false;
        ComponentNotifier.notify(_name, 'visibilityChanged');
    };

    /**
     * Returns true if the AppBar is currently hidden.
     * @returns {boolean}
     */
    isHidden = () => this._hidden;
}

const appBarEngine = new AppBarEngine();
export default appBarEngine;
